import _axios from "axios"
const axios = _axios.create({
	baseURL: process.env.REACT_APP_API_ROOT,
	withCredentials: true,
})

export const getActivityVotes = async (body) => {
	const response = await axios.post(`/campaign-new/activity-vote/cms/list`, body)
	return response
}

export const getActivityVoteById = async (id) => {
	const response = await axios.get(`/campaign-new/activity-vote/cms/${id}`)
	return response
}

export const saveActivityVote = async (body) => {
	const response = await axios.post(`/campaign-new/activity-vote/cms`, body)
	return response
}

export const editActivityVote = async (id, body) => {
	const response = await axios.put(`/campaign-new/activity-vote/cms/${id}`, body)
	return response
}

export const getReportActivityVote = async (id) => {
	const response = await axios.get(`/campaign-new/activity-vote/cms/${id}/report`)
	return response
}
export const getReportMemberActivityVote = async (id, page, limit) => {
	const response = await axios.get(`/campaign-new/activity-vote/cms/${id}/report-member`, {
		params: {
			page,
			limit,
		},
	})
	return response
}

export const changeIsActive = async (id, isActive) => {
	const response = await axios.get(`/campaign-new/activity-vote/cms/${id}/change-is-active`, {
		params: {
			isActive,
		},
	})
	return response
}
